// extracted by mini-css-extract-plugin
export var account = "_redotech-redo-return-app-lib-order-page-account";
export var accountDropdown = "_redotech-redo-return-app-lib-order-page-account-dropdown";
export var accountMenuList = "_redotech-redo-return-app-lib-order-page-account-menu-list";
export var accountMenuListItem = "_redotech-redo-return-app-lib-order-page-account-menu-list-item";
export var accountText = "_redotech-redo-return-app-lib-order-page-account-text";
export var avatar = "_redotech-redo-return-app-lib-order-page-avatar";
export var avatarContainer = "_redotech-redo-return-app-lib-order-page-avatar-container";
export var backArrow = "_redotech-redo-return-app-lib-order-page-back-arrow";
export var brand = "_redotech-redo-return-app-lib-order-page-brand";
export var brandContainer = "_redotech-redo-return-app-lib-order-page-brand-container";
export var cart = "_redotech-redo-return-app-lib-order-page-cart";
export var cartContainer = "_redotech-redo-return-app-lib-order-page-cart-container";
export var cartSizeBubble = "_redotech-redo-return-app-lib-order-page-cart-size-bubble";
export var cartTotalText = "_redotech-redo-return-app-lib-order-page-cart-total-text";
export var chevronDown = "_redotech-redo-return-app-lib-order-page-chevron-down";
export var grayText = "_redotech-redo-return-app-lib-order-page-gray-text";
export var hiddenButAccessible = "_redotech-redo-return-app-lib-order-page-hidden-but-accessible";
export var imageWrapper = "_redotech-redo-return-app-lib-order-page-image-wrapper";
export var logo = "_redotech-redo-return-app-lib-order-page-logo";
export var main = "_redotech-redo-return-app-lib-order-page-main";
export var nameText = "_redotech-redo-return-app-lib-order-page-name-text";
export var navBar = "_redotech-redo-return-app-lib-order-page-nav-bar";
export var navBarContent = "_redotech-redo-return-app-lib-order-page-nav-bar-content";
export var navBarLogo = "_redotech-redo-return-app-lib-order-page-nav-bar-logo";
export var page = "_redotech-redo-return-app-lib-order-page-page";
export var pageWrapper = "_redotech-redo-return-app-lib-order-page-page-wrapper";
export var sideButtons = "_redotech-redo-return-app-lib-order-page-side-buttons";
export var storeReturn = "_redotech-redo-return-app-lib-order-page-store-return";
export var storeReturnBlock = "_redotech-redo-return-app-lib-order-page-store-return-block";
export var textDanger = "_redotech-redo-return-app-lib-order-page-text-danger";
export var textSuccess = "_redotech-redo-return-app-lib-order-page-text-success";